import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function ContactUs() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Contact Us" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">     
                        <div className='col-md-12'>
                            <h2>Contact Us</h2>
                        </div>  
                    </div>    
                    <div className="row justify-content-center align-items-center">              
                        <div className="col-md-4 col-sm-4 col-xs-12">
                            <div className='contactustext'>
                                <div className='textwithicon'>
                                    <a href='tel:+918397979225'><i class="icon fal fa-phone"></i> +91-8397979225</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-12">
                            <div className='contactustext'>
                                <div className='textwithicon'>
                                    <a href='mailto:admissions@mvn.edu.in'><i class="icon fal fa-envelope"></i> admissions@mvn.edu.in</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-12">
                            <div className='contactustext'>
                                <div className='textwithicon'>
                                    <a href='mailto:admissions@mvn.edu.in'><i class="icon fal fa-map-marker-check"></i>  Delhi-Agra Highway, Aurangabad, Palwal, Haryana 121105</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center"> 
                        <div className="col-md-12">
                            <div className='map'>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.250416000488!2d77.33255616071196!3d28.016821125906468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39732db30911a2bd%3A0x1a95b70271a44d12!2sMVN%20University!5e0!3m2!1sen!2sin!4v1770263279190!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ContactUs